import React from "react";

const GuestLayout = ({children}) => {
    return(<section className="mainloginwrps">{children}</section>)
}

export default GuestLayout;